module.exports = __webpack_public_path__ + "img/img_lianghua_fuwutwo@3x.a684c1a0.png";